import '@aiax-hub/ui-tokens/tokens.css';
import './styles/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { createQueryClient } from './api/queryClient';
import { AppProviders } from './App';
import { createI18n } from './i18n';
import { appRoutes } from './routes';
import { useViewStore } from './state/store';

const queryClient = createQueryClient();
const i18n = createI18n(useViewStore.getState().lang);
const router = createBrowserRouter(appRoutes);

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing in index.html');
createRoot(root).render(
  <StrictMode>
    <AppProviders queryClient={queryClient} i18n={i18n}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
